/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Component, OnInit, Input } from '@angular/core';

import { WorkflowLogNode } from "../../../models/workflow-log-node";

@Component({
  selector: 'app-workflow-log-node',
  templateUrl: './workflow-log-node.component.html'
})
export class WorkflowLogNodeComponent implements OnInit {

    @Input()
    node: WorkflowLogNode;
    
    constructor() { }
    
    ngOnInit() {
        console.log(this.node);
    }

}
